import { c as _c } from "react/compiler-runtime";
import { Box, Center, Link, VStack } from '@chakra-ui/react';
import { UserAccessGateProps } from '@src/components/sco/UserAccessGate';
import { BoxedCardCTA } from '@src/components/sco/UserAccessGate/cta-variants/BoxedCardCTA';
import React, { useState } from 'react';
export const PageOverlayCTA = props => {
  const $ = _c(10);
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) {
    let t0;
    if ($[0] !== props) {
      t0 = <BoxedCardCTA {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <BoxedCardCTA {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link fontSize="10px" href="#" variant="underline" onClick={e => {
      e.preventDefault();
      setDismissed(true);
    }}>DISMISS</Link>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0) {
    t2 = <Box backdropFilter="blur(5px)" bgColor="blackAlpha.600" bottom={0} height="full" left={0} position="fixed" right={0} top={0} width="full" zIndex={99}><Center marginX="auto" maxWidth="600px" minHeight="80vh" width="full"><VStack>{t0}{t1}</VStack></Center></Box>;
    $[5] = t0;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.children || $[8] !== t2) {
    t3 = <Box height="100vh" maxHeight="100vh" overflow="hidden" width="full">{props.children}{t2}</Box>;
    $[7] = props.children;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};